import { AssetKind, Explorer } from "boltz-swaps/types";
import {
    type Config,
    baseConfig,
    chooseUrl,
    sameOrigin,
} from "src/configs/base";

// The API is served from the same origin as the web app (`/v2/...` and the
// WebSocket at `/v2/ws`) unless VITE_API_URL is set at build time.
const apiUrl =
    (import.meta.env.VITE_API_URL as string | undefined) || sameOrigin();

// Set at build time; the address is created on the live node's lnd wallet
// (lncli newaddress p2tr) and recorded in deploy/OPERATING.md
const donationAddress = import.meta.env.VITE_DONATION_ADDRESS as
    string | undefined;

const config = {
    ...baseConfig,
    network: "mainnet",
    donation: donationAddress ? { address: donationAddress } : undefined,
      ourNode: {
        pubkey: "036a319e23387dad4c6d2fd290f82f907997af16455e494f9c4afbc60342ef0e02",
        uris: [
            "162.35.38.42:9735",
            "tpts6yfdhggn2dbmdadib4dzhmswt5f2fn63q2z47yso5nxawvg4dlqd.onion:9735",
        ],
    },
    loglevel: "info",
    apiUrl: {
        normal: apiUrl,
    },
    assets: {
        BTC: {
            type: AssetKind.UTXO,
            blockExplorerUrl: {
                id: Explorer.Mempool,
                normal: "https://mempool.guide",
            },
            // mempool.guide sends no CORS headers, so the deployment proxies
            // its API at /explorer/api on the same origin
            blockExplorerApis: [
                {
                    id: Explorer.Mempool,
                    normal: `${sameOrigin()}/explorer/api`,
                },
            ],
        },
    },
} as Config;

export { config, chooseUrl };
